<!--
    CamerasDock.svelte

    The rail that lets the camera bubbles get out of the way.

    The bubbles sit across the top of the screen and cover the map. The resize handle only
    shrinks them, and only in multi-line mode, so there was no way to actually put them away.
    This rail is always in the same spot on the left edge - the button never moves between
    the two states - and holds:

      - the toggle, which hides or brings back the bubbles;
      - while hidden, one small avatar per participant, lit up while that person is speaking.

    The lit ring reads from the same store the bubble uses for its "is talking" background
    (Streamable.showVoiceIndicator), so the two can never disagree about who has the floor.
-->
<script lang="ts">
    import { streamableCollectionStore } from "../../Stores/StreamableCollectionStore";
    import { camerasDockedStore } from "../../Stores/CamerasDockStore";
    import LL from "../../../i18n/i18n-svelte";
    import { IconChevronLeft, IconUsers } from "@wa-icons";
    import CameraDot from "./CameraDot.svelte";

    let videoBoxes = $derived([...$streamableCollectionStore.values()]);
</script>

<div
    class="pointer-events-none fixed start-2 top-1/2 z-[350] flex -translate-y-1/2 flex-col items-center gap-2"
    data-testid="cameras-dock"
>
    <button
        type="button"
        class="group/dock-toggle pointer-events-auto relative flex h-9 w-9 items-center justify-center rounded-full bg-contrast/70 text-white opacity-60 shadow-md backdrop-blur transition-all duration-150 hover:bg-white/10 hover:opacity-100"
        aria-pressed={$camerasDockedStore}
        aria-label={$camerasDockedStore ? $LL.video.show_cameras() : $LL.video.hide_cameras()}
        data-testid="toggle-cameras-dock"
        onclick={() => camerasDockedStore.toggle()}
    >
        {#if $camerasDockedStore}
            <IconUsers font-size="18" />
        {:else}
            <IconChevronLeft font-size="20" />
        {/if}

        <span
            class="pointer-events-none absolute start-11 whitespace-nowrap rounded bg-contrast/90 px-2 py-1 text-xs opacity-0 backdrop-blur transition-opacity duration-150 group-hover/dock-toggle:opacity-100"
        >
            {$camerasDockedStore ? $LL.video.show_cameras() : $LL.video.hide_cameras()}
        </span>
    </button>

    {#if $camerasDockedStore}
        <div class="pointer-events-auto flex max-h-[60vh] flex-col items-center gap-2 overflow-y-auto py-1">
            {#each videoBoxes as videoBox (videoBox.uniqueId)}
                <CameraDot {videoBox} />
            {/each}
        </div>
    {/if}
</div>
